import { render, staticRenderFns } from "./LangChooser.vue?vue&type=template&id=4b137240&"
import script from "./LangChooser.vue?vue&type=script&lang=js&"
export * from "./LangChooser.vue?vue&type=script&lang=js&"
import style0 from "./LangChooser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports